export default __webpack_public_path__ + "static/white-q-8ce1582ea06c36cf7c126c74b183fb44.svg";